export default "__VITE_ASSET__451deca2__"